import * as wipDB from './wipdb.json';

export const TagGroupList =  ['Interests', 'Objectives', 'Milestones'];
export const TagsInit = { 'Interests' : [], 'Objectives' : [], 'Milestones' : [] };

export function getMicroExperienceTags() {
    // TODO : turn this into an API call to experience-api tag service
    return Promise.resolve(wipDB.Tags || {});
}